import { render, staticRenderFns } from "./DetailsToolbar.vue?vue&type=template&id=b0c798dc&scoped=true&"
import script from "./DetailsToolbar.vue?vue&type=script&lang=js&"
export * from "./DetailsToolbar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsToolbar.vue?vue&type=style&index=0&id=b0c798dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c798dc",
  null
  
)

export default component.exports